import { useCreditStatus } from '../../SptPriceDetailsContext';

export default function useGetCoApplicant(): string {
  const { hasCoApplicant = false, coapplicant } = useCreditStatus();

  const { firstName = '', lastName = '' } = coapplicant ?? {};

  return hasCoApplicant ? `${firstName} ${lastName}` : '';
}
